import { render, staticRenderFns } from "./SectionContent.vue?vue&type=template&id=625b7616"
import script from "./SectionContent.vue?vue&type=script&lang=js"
export * from "./SectionContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports